<!-- <ngx-spinner type="ball-scale-multiple"></ngx-spinner> -->

<!-- Start Our Works Area -->
<section id="works" class="our-works ptb-100">
    <div class="container">

        <div class="row">
            <div class="col-lg-8 offset-lg-2 text-center">
                <div class="section-title">
                    <h2>Designs Dee Portfolio</h2>
                    <p>Our portfolio is not just a series of media executions combining catchy phrases and attractive
                        images. Instead, we have focused on a highly strategic approach combining a comprehensive
                        understanding of design aesthetics, marketing, customer motivation and behaviour, as well as
                        constant monitoring and analysis to achieve highly effective solutions </p>
                    <p>
                        This has been made possible by our Creative Team which comprises individuals who are experts in
                        Design Creation, Animation, Video Production, Social Media Marketing, Web Design and Public
                        Relations. We're dedicated to providing you with the very best of creativity and effective
                        service in a timely and efficient manner. References from our satisfied clients have been
                        attached on this website.
                    </p>

                    <span class="section-title-bg">Portfolio</span>
                </div>
            </div>
        </div>

        <div id="filters" class="filter-menu text-center roxy-projects-active">
            <ul>

                <li [class]=activeTab_branding data-filter=".branding" (click)="filter('branding');showPreloader()">
                    Branding & Promotions</li>
                <li [class]=activeTab_digital data-filter=".digital" (click)="filter('digital');showPreloader()">Digital
                    Marketing</li>
                <li [class]=activeTab_tv data-filter=".tv" (click)="filter('tv');showPreloader()">TV Ads</li>
                <li [class]=activeTab_animation data-filter=".animation" (click)="filter('animation');showPreloader()">
                    Video Creations</li>
                <li [class]=activeTab_news_letter data-filter=".news-letter"
                    (click)="filter('news-letter');showPreloader()">E-News Letters</li>
                <!-- <li class="" data-filter=".creative">Creative Designs</li> -->
                <li [class]=activeTab_logo data-filter=".logo" (click)="filter('logo');showPreloader()">Logo</li>
                <li [class]=activeTab_all data-filter="*" (click)="filter('');showPreloader()">All</li>

            </ul>
        </div>

        <!-- <div id="Portfolio" class="row">  -->
        <div id="" class="row">
            <div class="col-sm-6 col-lg-4 filtr-item web" [ngClass]="image.class"
                *ngFor="let image of items; let i=index">

                <div class="work-details" (click)="open(i)" *ngIf="image.type == 'image'">
                    <img [src]="image.thumb" [alt]="image.caption">
                </div>

                <div class="work-details" *ngIf="image.type == 'page'">
                    <img [src]="image.thumb" [alt]="image.caption">
                    <div class="box-content" *ngIf="image.type == 'page'">
                        <h3 class="title">Campaign Details</h3>
                        <ul class="icon">
                            <li><a [href]="image.link"><i class="fa fa-link"></i></a></li>
                        </ul>
                    </div>
                </div>


                <div class="work-details" *ngIf="image.type == 'video' || image.type == 'pdf'">
                    <!-- {{image.link}} -->
                    <!-- <button (click)="openPopup(image.link)">Show Preloader</button> -->

                    <div class="videos" *ngIf="image.type == 'video'" (click)="openPopup(image.link)">
                        <div class="video">
                            <span></span>
                            <img [src]="image.thumb" [alt]="image.caption">
                        </div>
                    </div>

                    <div class="pdfs" *ngIf="image.type == 'pdf'" (click)="openPopup(image.link)">
                        <div class="pdf">
                            <span></span>
                            <img [src]="image.thumb" [alt]="image.caption">
                        </div>
                    </div>

                </div>


            </div>

        </div>
    </div>
</section>
<!-- End Our Works Area -->


<!-- <router-outlet></router-outlet> -->

<div class="site-preloader-wrap" [ngClass]="{'hidden': !isVisible}">
    <div class="sk-cube-grid">
        <div class="sk-cube sk-cube1"></div>
        <div class="sk-cube sk-cube2"></div>
        <div class="sk-cube sk-cube3"></div>
        <div class="sk-cube sk-cube4"></div>
        <div class="sk-cube sk-cube5"></div>
        <div class="sk-cube sk-cube6"></div>
        <div class="sk-cube sk-cube7"></div>
        <div class="sk-cube sk-cube8"></div>
        <div class="sk-cube sk-cube9"></div>
    </div>
</div>

<!-- 
<button (click)="showLoader()">Show Preloader</button>
    <button (click)="hidePreloader()">Hide Preloader</button> -->


<!-- <button (click)="openPopup('https://www.youtube.com/embed/dQw4w9WgXcQ')">
        Play YouTube Video
      </button>
      <button (click)="openPopup('https://player.vimeo.com/video/76979871')">
        Play Vimeo Video
      </button> -->

<app-video-popup *ngIf="showPopup" [videoUrl]="selectedVideoUrl" (closed)="closePopup()">
</app-video-popup>